import { createApp } from '@app/adapters/create-app'

import PulseWorkflowProgress from '../components/pulse-workflow-progress'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='pulse-workflow-progress']").each(function () {
    const component = createApp(PulseWorkflowProgress)

    component.mount(this)
  })
})
